import { configureStore } from '@reduxjs/toolkit'
import { PROD_ENV } from '../utilities/constants'
import emailSliceReducer from './states/emailSlice'
import errorSliceReducer from './states/errorSlice'

export const store = configureStore({
    reducer: {
        email: emailSliceReducer,
        error: errorSliceReducer
    },
    devTools: process.env.REACT_APP_ENVIRONMENT !== PROD_ENV
})